export default "__VITE_ASSET__DFv89Evt__"